export default __webpack_public_path__ + "static/media/Circly_List_Deletion_1.47d133bb.gif";